import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/search.svg";
var SearchSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  SearchSolid_default as default
};
